<template>
  <div class="form__group" v-click-outside="closeCountryList">
    <input
      v-model="countrySearchQuery"
      type="tel"
      id="countriesInput"
      class="form__field"
      placeholder="Country"
      autocomplete="off"
      required
      @click="openCountryList = true"
      @change="openCountryList = true"
    />
    <i class="fas fa-globe input-icon"></i>
    <label for="countriesInput" class="form__label">{{
      selectedCountry ? selectedCountry.name : "Country"
    }}</label>
    <div v-if="openCountryList" class="countryList-container">
      <ul class="list-group">
        <li
          class="list-group-item country-item"
          v-for="country in countrySearchResult.length > 0 ||
          countrySearchQuery.length > 0
            ? countrySearchResult
            : countries"
          :key="country.id"
          @click="selectCountry(country)"
        >
          <span style="margin-right: 2rem"
            ><img
              class="country-flag"
              :src="
                '/img/flags/' +
                countries
                  .find(place => place.name == country.name)
                  .alpha2.toLowerCase() +
                '.png'
                  ? '/img/flags/' +
                    countries
                      .find(place => place.name == country.name)
                      .alpha2.toLowerCase() +
                    '.png'
                  : ''
              "
              alt="country-flag"
          /></span>
          <span>{{ country.name }}</span>
        </li>
        <li
          class="list-group-item"
          v-if="
            countrySearchResult.length === 0 && countrySearchQuery.length > 0
          "
        >
          Can`t find such country
        </li>
      </ul>
    </div>
    <span
      class="reset-select"
      @click="[selectedCountry = null, countrySearchQuery='']"
      v-if="selectedCountry"
      ><i class="fas fa-times"></i
    ></span>
  </div>
</template>

<script>
import vClickOutside from "v-click-outside";
import { mapState } from "vuex";

export default {
  name: "CountrySelect",
  computed: {
    ...mapState("clients", ["dictionaries"])
  },
  directives: {
    clickOutside: vClickOutside.directive
  },
  props: {
    countries: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      countrySearchResult: [],
      countrySearchQuery: "",
      openCountryList: false,
      selectedCountry: null
    };
  },
  methods: {
    closeCountryList() {
      this.openCountryList = false;
    },
    filterCountries(countrySearchQuery) {
      this.countrySearchResult = this.countries.filter(country => {
        countrySearchQuery = countrySearchQuery.trim();
        countrySearchQuery = countrySearchQuery.toLowerCase();
        let afterRegex = countrySearchQuery.replace(
          /[.*+\-?^${}()|[\]\\]/g,
          ""
        );
        return country.name.toLowerCase().includes(afterRegex);
      });
    },
    selectCountry(country) {
      this.selectedCountry = country;
      this.countrySearchQuery = country.name;
      this.openCountryList = false;
    }
  },
  watch: {
    countrySearchQuery() {
      this.filterCountries(this.countrySearchQuery);
    },
    selectedCountry() {
      this.$emit("selectCountry", this.selectedCountry);
    }
  }
};
</script>

<style scoped lang="scss">
$bgColor: #009788;
$borderColor: #01756a;
.form__group {
  position: relative;
  padding: 15px 0 0;
  margin-top: 10px;
}
.form__field {
  font-family: inherit;
  width: 100%;
  border: 0;
  border-bottom: 1px solid #d2d2d2;
  outline: 0;
  font-size: 16px;
  color: #212121;
  padding: 7px 0;
  background: transparent;
  transition: border-color 0.2s;
}

.form__field::placeholder {
  color: transparent;
}

.form__field:placeholder-shown ~ .form__label {
  font-size: 16px;
  cursor: text;
  top: 20px;
}

label,
.form__field:focus ~ .form__label {
  position: absolute;
  top: 0;
  display: block;
  transition: 0.2s;
  font-size: 12px;
  color: #9b9b9b;
}

.form__field:focus ~ .form__label {
  color: $bgColor;
}
.form__field:focus ~ .input-icon {
  color: $bgColor;
}

.form__field:focus {
  padding-bottom: 6px;
  border-bottom: 2px solid $bgColor;
}
/*Inputs custom style ends ############################################################# */
.modal-content {
  padding: 5%;
}
.input-icon {
  position: absolute;
  left: -30px;
  top: 25px;
  font-size: 1.9rem;
}
.countryList-container {
  max-height: 250px;
  //min-height: 100px;
  overflow-y: auto;
  position: absolute;
  background-color: white;
  width: 100%;
  z-index: 1;
}

/*Scroll custom style starts ############################################################# */

.countryList-container::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #f5f5f5;
}

.countryList-container::-webkit-scrollbar {
  width: 7px;
  background-color: $bgColor;
  /*display: none;*/
}

.countryList-container::-webkit-scrollbar-thumb {
  background-color: $bgColor;
  border: 2px solid $borderColor;
  border-radius: 5px;
}
/*Scroll custom style ends ############################################################# */

.country-item {
  color: $bgColor;
  transition: all 0.2ms ease-in-out;
}
.country-item:hover {
  background-color: #ebebeb;
  cursor: pointer;
}
.reset-select {
  position: absolute;
  cursor: pointer;
}
.reset-select:hover {
  color: grey;
}
</style>
